import { useQuery } from 'react-query';

import { DataRoomContact, Guid } from '../../models';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';
import { QueryKeys } from '.';

export function useDataRoomContactsQuery(guid: Guid | undefined) {
	const api = useApi();

	return useQuery(
		QueryKeys.DataRoomContacts.Root(guid),
		() => AxiosUtils.getResponseData<DataRoomContact[]>(api.get(CerebroApiEndpoints.DataRoomContacts.Root(guid))),
		{ enabled: guid !== undefined }
	);
}
